"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _link = _interopRequireDefault(require("../../../core/link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: "3"
}, "Competition"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: "3"
}, "Day"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "2",
  className: "cell-border-left"
}, "Daily Limit"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "8",
  className: "text-xs-center cell-border-left"
}, "Included in Day Limit"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "3",
  className: "text-xs-center cell-border-left"
}, "Not Triggering Day Limit")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: "2",
  className: "cell-border-left"
}, "Divisions Included"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: "2",
  className: "text-xs-right"
}, "Max"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: "2",
  className: "text-xs-right cell-border-left"
}, "Reserved Places"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "2",
  className: "text-xs-center cell-border-left"
}, "Accepted"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "2",
  className: "text-xs-center cell-border-left"
}, "Offered"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: "2",
  className: "text-xs-center cell-border-left"
}, "Available Places"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "2",
  className: "text-xs-center cell-border-left"
}, "Waiting"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: "2",
  className: "text-xs-right cell-border-left"
}, "Accepted"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: "2",
  className: "text-xs-right"
}, "Offered"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: "2",
  className: "text-xs-right"
}, "Waiting")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right cell-border-left"
}, "Host"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Others"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right cell-border-left"
}, "Host"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Others"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right cell-border-left"
}, "Host"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Others")));
class PlaceAvailabilityTable extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getCompLink", day => {
      if (!day.isPublished && !day.isAdministratedByUser) return day.competitionName;
      return /*#__PURE__*/_react.default.createElement(_link.default, {
        to: '/year/' + this.props.yearID + '/competition/' + day.competitionSlug
      }, day.competitionName);
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.stats.map(day => /*#__PURE__*/_react.default.createElement("tr", {
      key: day.competitionDayID
    }, /*#__PURE__*/_react.default.createElement("td", null, this._getCompLink(day)), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(day.raceDate, 'ddd')), /*#__PURE__*/_react.default.createElement("td", {
      className: "cell-border-left"
    }, day.divisionsInLimit), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, day.entryLimit), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left"
    }, day.reservedEntry), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left"
    }, day.hostEntriesAcceptedTriggeringLimit), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, day.otherEntriesAcceptedTriggeringLimit), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left"
    }, day.hostPlacesOfferedTriggeringLimit), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, day.otherPlacesOfferedTriggeringLimit), /*#__PURE__*/_react.default.createElement("td", {
      className: ' cell-border-left text-xs-right ' + (day.placesAvailable < 0 ? 'table-danger' : day.placesAvailable > 10 ? 'table-success' : day.placesAvailable > 0 ? 'table-warning' : '')
    }, day.placesAvailable), /*#__PURE__*/_react.default.createElement("td", {
      className: 'cell-border-left text-xs-right ' + (day.hostWaitingTriggeringLimit && day.hostWaitingTriggeringLimit > day.placesAvailable ? 'table-danger' : '')
    }, day.hostWaitingTriggeringLimit), /*#__PURE__*/_react.default.createElement("td", {
      className: 'text-xs-right ' + (day.otherWaitingTriggeringLimit && day.hostWaitingTriggeringLimit + day.otherWaitingTriggeringLimit > day.placesAvailable ? 'table-warning' : '')
    }, day.otherWaitingTriggeringLimit), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right cell-border-left"
    }, day.entriesAcceptedNotTriggeringLimit), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, day.placesOfferedNotTriggeringLimit), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, day.waitingNotTriggeringLimit)))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = PlaceAvailabilityTable;